import axios from 'axios'
import { message } from 'ant-design-vue'

function getBaseUrl(url) {
  // 本地开发或独立应用变更一下urls内容
  const urls = {
    middlewareUrl: '',
  }
  return window.urlConfig ? window.urlConfig.requests[url] : urls[url]
}

/**
 *
 * @param {*} url url
 * @param {*} tokenType token类型  取值范围：aToken | bToken | noneToken
 * @param {*} tIdType 租户id类型   取值范围：aTenantId | bTenantId | noneTenantId
 * @returns
 */
function newRequest(url, tokenType, tIdType) {
  const service = axios.create({})

  service.interceptors.request.use(
    async (config) => {
      config.baseURL = getBaseUrl(url)

      // token
      const tokens = {
        aToken: localStorage.getItem('CHOICELINK_A_TOKEN'),
        bToken: localStorage.getItem('CHOICELINK_B_TOKEN'),
        noneToken: '',
      }
      if (tokens[tokenType] && !config.headers['Authorization']) config.headers['Authorization'] = `Bearer ${tokens[tokenType]}`

      // 用户中心或平台中心租户
      const tenantIds = {
        aTenantId: localStorage.getItem('CHOICELINK_A_TID'),
        bTenantId: localStorage.getItem('CHOICELINK_B_TID'),
        noneTenantId: '',
      }
      if (tenantIds[tIdType] && !config.headers['Abp.TenantId']) config.headers['Abp.TenantId'] = tenantIds[tIdType]

      return config
    },
    (err) => {
      console.error(err)
      return Promise.reject(err)
    }
  )

  service.interceptors.response.use(
    (res) => res.data,
    (err) => {
      const data = err.response.data
      if (err.response.status === 403) {
        message.error('未有此操作权限')
      }
      if (err.response.status === 401 && !(data.result && data.result.isLogin)) {
        message.error('登录认证失效，请重新登录')
      }
      return data
    }
  )
  return service
}

const aTenantService = newRequest('middlewareUrl', 'aToken', 'aTenantId')
const bTenantService = newRequest('middlewareUrl', 'bToken', 'bTenantId')
const noneTenantService = newRequest('middlewareUrl', 'noneToken', 'noneTenantId')

export { aTenantService, bTenantService, noneTenantService }
